import React, { useEffect, useState } from "react";
import stylesheet from "./header.module.css";
import { Link } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Menu, message, Space, Button, Drawer, Radio } from "antd";
import Product_image2 from "../../../assets/images/CBD2.webp";
import Logo from "../../../assets/images/logoalpha.png";
import Profile from "../../../assets/images/user.png";
import Globe from "../../../assets/images/globe.png";
import Search from "../../../assets/images/search.png";
import CartImage from "../../../assets/images/cart.png";
import { getTheme } from "../../../actions/localtheme";
import { connect } from "react-redux";
import "../../../App.css";
import Cart from "../../page/cart";
import Login from "../../page/login";

const Header = (props) => {
  useEffect(() => {
    props.getTheme();
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = (e) => {
    const header = document.querySelector(".header-section");
    const scrollTop = window.scrollY;
    scrollTop >= 250
      ? header.classList.add("is-sticky")
      : header.classList.remove("is-sticky");
  };
  const menu = (
    <Menu
      items={[
        {
          label: <Link to={"/resources"}>RESOURCES</Link>,
          key: "1",
        },
        {
          label: <Link to={"/faqs"}>FAQs</Link>,
          key: "2",
        },
        {
          label: <Link to={"/reviews"}>REVIEWS</Link>,
          key: "3",
        },
        {
          label: <Link to={"/sponcers"}>SPONCERS</Link>,
          key: "4",
        },
        {
          label: <Link to={"/influencers"}>INFLUENCERS</Link>,
          key: "5",
        },
        {
          label: <Link to={"/affilate"}>AFFILIATES</Link>,
          key: "6",
        },
        {
          label: <Link to={"/event"}>EVENTS</Link>,
          key: "7",
        },
        {
          label: <Link to={"/blogs"}>BLOG</Link>,
          key: "8",
        },
      ]}
    />
  );
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [render, setrender] = useState("cart");
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const onChange = (e) => {
    setPlacement(e.target.value);
  };
  console.log(props.ThemeReducer.theme, "mr_taha");
  return (
    <>
      <Drawer
        placement={placement}
        closable={false}
        onClose={onClose}
        open={open}
        key={placement}
      >
        {render == "cart" ? <Cart /> : "" || render == "login" ? <Login /> : ""}
      </Drawer>
      <div
        style={{ background: props.ThemeReducer.theme }}
        className={`container-fluid py-3 header-section ${stylesheet.main_header}`}
      >
        <div className="row">
          <div className="col-lg-7 px-4 d-flex">
            <div className={stylesheet.LOGO}>
              <Link to="/">
                <img className="img-fluid" src={Logo} alt="" />
              </Link>
            </div>
            <div className={stylesheet.Navigation_side}>
              <div className={stylesheet.Navigation_side1}>
                <Link className={stylesheet.Navigation_side1_one} to="/aboutus">
                  ABOUT US
                </Link>
                <Link className={stylesheet.Navigation_side1_two} to="/aboutus">
                  ABOUT US
                </Link>
              </div>
              <div className={stylesheet.Navigation_side2}>
                <Link className={stylesheet.Navigation_side2_one} to="/shop">
                  PRODUCTS
                </Link>
                <Link className={stylesheet.Navigation_side2_two} to="/shop">
                  PRODUCTS
                </Link>
              </div>
              <div className={stylesheet.Navigation_side3}>
                <Link
                  className={stylesheet.Navigation_side3_one}
                  to="/services"
                >
                  SERVICES
                </Link>
                <Link
                  className={stylesheet.Navigation_side3_two}
                  to="/services"
                >
                  SERVICES
                </Link>
              </div>
              <div className={stylesheet.Navigation_side4}>
                <Link className={stylesheet.Navigation_side4_one} to="/vendors">
                  VENDORS
                </Link>
                <Link className={stylesheet.Navigation_side4_two} to="/vendors">
                  VENDORS
                </Link>
              </div>
              <div className={stylesheet.Navigation_side4}>
                <Dropdown overlay={menu}>
                  <a onClick={(e) => e.preventDefault()}>&MORE</a>
                </Dropdown>
              </div>
            </div>
          </div>
          <div
            className={`col-lg-5 d-flex align-items-center justify-content-end ${stylesheet.rigth_navigation} pr-5`}
          >
            <div
              onClick={() => {
                setrender("cart");
                showDrawer();
              }}
            >
              <img className={stylesheet.cart} src={CartImage} />
            </div>
            <div
              onClick={() => {
                setrender("search");
                showDrawer();
              }}
            >
              <img className={stylesheet.search} src={Search} />
            </div>
            <div
              onClick={() => {
                setrender("login");
                showDrawer();
              }}
            >
              <img className={stylesheet.user} src={Profile} />
            </div>
            <div>
              <img className={stylesheet.globe} src={Globe} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  ThemeReducer: state.ThemeReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getTheme: (theme) => dispatch(getTheme(theme)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Header);
